import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "lobby" }
const _hoisted_2 = { class: "lobby__header" }
const _hoisted_3 = { class: "lobby__timer" }
const _hoisted_4 = {
  key: 0,
  class: "lobby__countdown"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "lobby__description" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconRoomServiceOutline = _resolveComponent("IconRoomServiceOutline")
  const _component_NcRichText = _resolveComponent("NcRichText")
  const _component_MediaSettings = _resolveComponent("MediaSettings")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconRoomServiceOutline, { size: 64 }),
      _createElementVNode("h2", null, _toDisplayString($options.currentConversationName), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString($options.t('spreed', 'You are currently waiting in the lobby')), 1),
      ($options.lobbyTimer)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createTextVNode(_toDisplayString($options.message) + " ", 1),
            ($options.relativeDate)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "lobby__countdown relative-timestamp",
                  title: $options.startTime
                }, " - " + _toDisplayString($options.relativeDate), 9, _hoisted_5))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_NcRichText, {
          text: $options.conversation.description,
          dir: "auto",
          autolink: "",
          "use-extended-markdown": ""
        }, null, 8, ["text"])
      ])
    ]),
    _createVNode(_component_MediaSettings, { "is-dialog": false })
  ]))
}